import { Component, inject } from '@angular/core';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';

@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.css']
})
export class EmailTemplateComponent {
  CompanyID: number  = 0;

  User = inject(UserLoginService).User();
  
  ngOnInit(){
    this.CompanyID = this.User.companyId
  }

  

}
